import SEO from "@/components/SEO";
import { PageHero, Reveal, Kicker, Rich, UL } from "@/components/Bits";
import EnquiryForm from "@/components/EnquiryForm";
import { CONTACT } from "@/content/policies";
import { Scale, Timer, FileWarning } from "lucide-react";

export default function Grievance() {
  return (
    <div data-testid="grievance-page">
      <SEO
        title="Grievance Support"
        description="Middle Man Grievance Officer — Mr. Tushar Kamalakar Shinde, CEO, Tourist Junction Private Limited, Pune. Acknowledgement within 48 working hours under the IT Rules 2021."
        path="/grievance"
      />
      <PageHero
        kicker="Grievance support"
        title="Raise a grievance. Get a resolution."
        subtitle="In compliance with Rule 3(2)(a) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021."
      />

      <div className="mx-auto max-w-6xl px-6 py-16 md:py-20">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr]">
          <div className="space-y-12">
            <Reveal>
              <div className="border border-line bg-white p-8" data-testid="grievance-officer">
                <Scale className="h-6 w-6 text-brand" strokeWidth={1.7} />
                <h2 className="mt-5 font-serif text-2xl font-semibold tracking-tight">Grievance Officer</h2>
                <div className="mt-5 space-y-3 text-[15px] leading-relaxed text-mute">
                  <Rich text={`**Name:** ${CONTACT.grievanceName}`} />
                  <Rich text={`**Designation:** ${CONTACT.grievanceRole}`} />
                  <Rich text={`**Address:** ${CONTACT.address}`} />
                  <p>
                    <strong className="font-semibold text-ink">Phone:</strong>{" "}
                    <a href={CONTACT.phoneHref} data-testid="grievance-phone" className="font-semibold text-brand">{CONTACT.phone}</a>
                  </p>
                  <p>
                    <strong className="font-semibold text-ink">Email:</strong>{" "}
                    <a href={`mailto:${CONTACT.email}?subject=GRIEVANCE`} data-testid="grievance-email" className="font-semibold text-brand">
                      {CONTACT.email}
                    </a>{" "}
                    (subject: “GRIEVANCE — [order id]”)
                  </p>
                </div>
              </div>
            </Reveal>

            <Reveal>
              <div className="border border-line bg-white p-8">
                <Timer className="h-6 w-6 text-brand" strokeWidth={1.7} />
                <h2 className="mt-5 font-serif text-2xl font-semibold tracking-tight">Response time</h2>
                <div className="mt-5">
                  <UL items={[
                    "Grievances are acknowledged within 48 working hours.",
                    "We aim to resolve matters within the timelines set by the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021 and the Digital Personal Data Protection Act, 2023 as they become applicable.",
                  ]} />
                </div>
              </div>
            </Reveal>

            <Reveal>
              <div className="border border-line bg-white p-8">
                <FileWarning className="h-6 w-6 text-brand" strokeWidth={1.7} />
                <h2 className="mt-5 font-serif text-2xl font-semibold tracking-tight">Before you write</h2>
                <div className="mt-5">
                  <UL items={[
                    "For app bookings and orders, the fastest route is the in-app complaint option on the job or order screen.",
                    "Include your registered mobile number and any supporting screenshots.",
                    "For payment issues (for example a duplicate debit), include the payment reference.",
                  ]} />
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div>
              <Kicker>Grievance form</Kicker>
              <h2 className="mt-5 font-serif text-2xl font-semibold tracking-tight md:text-3xl">Submit a grievance</h2>
              <p className="mb-8 mt-3 text-sm leading-relaxed text-mute">
                Your submission is saved with a reference number and routed to the Grievance Officer.
              </p>
              <EnquiryForm kind="grievance" testid="grievance-form" showOrderId buttonLabel="Submit grievance" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
